const signin = user => {
  return fetch("/api/auth/signin/", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    credentials: "include",
    body: JSON.stringify(user)
  })
    .then(response => {
      return response.json();
    })
    .catch(err => console.log(err));
};

const signout = () => {
  localStorage.removeItem("jwt");
  return;
};

export { signin, signout };



// WEBPACK FOOTER //
// ./src/components/auth/authApi.js